import React from "react";

import imageSplitData from "../../../shared/data/ImageSplitData";
import { NavLink } from 'react-router-dom';

import "./ImageSplit.css";


const ImageSplit = function (props) {




    return (
        <div className="imagesplit-container">
            {Object.values(imageSplitData).map((data, idx) => (
                <NavLink to="/sparten" exact="true">
                    <div key={idx} className="imagesplit-box">
                        <img src={data.img} alt={data.text} />
                        <h2>{data.text}</h2>
                    </div>
                </NavLink>
            ))}
        </div>
    );
}

export default ImageSplit;


// <div className="imagesplit-box">
// <img src="https://source.unsplash.com/1000x800" />
// <h2 data-cta="Get out there TEST TEST→">Muay Thai</h2>
// {/* <span>Muay Thai</span> */}
// </div>
// <div className="imagesplit-box">
// <img src="https://source.unsplash.com/1000x802" />
// <h2 data-cta="Get out there TEST TEST→">MMA</h2>
// </div>
// <div className="imagesplit-box">
// <img src="https://source.unsplash.com/1000x804" />
// {/* <span>Kettlebells</span> */}
// <h2 data-cta="Get out there TEST TEST→">Kettlebells</h2>
// </div>
// <div className="imagesplit-box">
// <img src="https://source.unsplash.com/1000x806" />
// <h2 data-cta="Get out there TEST TEST→">Powerlifting</h2>
// </div>
// <div className="imagesplit-box">
// <img src="https://source.unsplash.com/1000x808" />
// <h2 data-cta="Get out there TEST TEST→">Bodybuilding</h2>
// </div>